import React from 'react';
import './PageLoadingFallback.css';

/** Shown while a lazy-loaded route chunk is downloading. */
export default function PageLoadingFallback() {
  return (
    <div className="page-loading-fallback" role="status" aria-live="polite" aria-label="Loading page">
      <div className="page-loading-fallback__spinner" aria-hidden="true" />
    </div>
  );
}
